import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { AuthStore, isMemberUser } from '@/app/core/auth/auth.store';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model(); track $index) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [root]="true"></li>
            } @else {
                <li class="menu-separator"></li>
            }
        }
    </ul> `
})
export class AppMenu {
    private readonly authStore = inject(AuthStore);

    readonly model = computed(() => (this.isMember() ? this.memberMenu : this.mainMenu));

    private readonly mainMenu: any[] = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            items: [
                {
                    label: 'Ventas Electr\u00f3nicas',
                    icon: 'pi pi-fw pi-receipt',
                    routerLink: ['/sales-electronic'],
                    path: '/sales-electronic'
                },
                {
                    label: 'Inventario',
                    icon: 'pi pi-fw pi-box',
                    path: '/inventario',
                    items: [
                        {
                            label: 'Categor\u00edas',
                            icon: 'pi pi-fw pi-tags',
                            routerLink: ['/categories'],
                            path: '/inventario/categories'
                        },
                        {
                            label: 'Localidades',
                            icon: 'pi pi-fw pi-map-marker',
                            routerLink: ['/locations'],
                            path: '/inventario/locations'
                        },
                        {
                            label: 'Productos',
                            icon: 'pi pi-fw pi-box',
                            routerLink: ['/products'],
                            path: '/inventario/products'
                        },
                        {
                            label: 'Compras',
                            icon: 'pi pi-fw pi-upload',
                            routerLink: ['/purchases-upload'],
                            path: '/inventario/purchases-upload'
                        }
                    ]
                },
                {
                    label: 'Configuraci\u00f3n',
                    icon: 'pi pi-fw pi-cog',
                    routerLink: ['/configuracion'],
                    path: '/configuracion',
                    items: [
                        {
                            label: 'Proveedores',
                            icon: 'pi pi-fw pi-truck',
                            routerLink: ['/providers'],
                            path: '/configuracion/providers'
                        },
                        {
                            label: 'Clientes',
                            icon: 'pi pi-fw pi-users',
                            routerLink: ['/customers'],
                            path: '/configuracion/customers'
                        }
                    ]
                },
                {
                    label: 'Reportes',
                    icon: 'pi pi-chart-line',
                    path:'reports',
                    items: [
                        {
                            label: 'Dashboard',
                            icon: 'pi pi-chart-line',
                            routerLink: ['/reports-dashboard'],
                            path: '/reports-dashboard'
                        },
                        {
                            label: 'Ventas',
                            icon: 'pi pi-chart-bar',
                            routerLink: ['/sales-report'],
                            path: '/sales-report'
                        },
                        {
                            label: 'Compras',
                            icon: 'pi pi-shopping-cart',
                            routerLink: ['/purchase-report'],
                            path: '/purchase-report'
                        },
                        this.createSalesBooksMenu(),
                        this.createAnnexesMenu()
                    ]
                }
            ]
        }
    ];

    private readonly memberMenu: any[] = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            items: [
                {
                    label: 'Reportes',
                    icon: 'pi pi-chart-line',
                    path: 'reports',
                    items: [
                        {
                            label: 'Dashboard',
                            icon: 'pi pi-chart-line',
                            routerLink: ['/reports-dashboard'],
                            path: '/reports-dashboard'
                        },
                        {
                            label: 'Ventas',
                            icon: 'pi pi-chart-bar',
                            routerLink: ['/sales-report'],
                            path: '/sales-report'
                        },
                        {
                            label: 'Compras',
                            icon: 'pi pi-shopping-cart',
                            routerLink: ['/purchase-report'],
                            path: '/purchase-report'
                        },
                        this.createSalesBooksMenu(),
                        this.createAnnexesMenu()
                    ]
                }
            ]
        }
    ];

    private isMember(): boolean {
        return isMemberUser(this.authStore.user());
    }

    private createSalesBooksMenu(): any {
        return {
            label: 'Libros de ventas',
            icon: 'pi pi-book',
            path: '/sales-books',
            items: [
                {
                    label: 'Consumidores',
                    icon: 'pi pi-users',
                    routerLink: ['/sales-book-consumers'],
                    path: '/sales-book-consumers'
                },
                {
                    label: 'Contribuyentes',
                    icon: 'pi pi-briefcase',
                    routerLink: ['/sales-book-taxpayers'],
                    path: '/sales-book-taxpayers'
                }
            ]
        };
    }

    private createAnnexesMenu(): any {
        return {
            label: 'Anexos',
            icon: 'pi pi-folder-open',
            path: '/annexes',
            items: [
                {
                    label: 'Consumidores',
                    icon: 'pi pi-users',
                    routerLink: ['/annexes-consumers'],
                    path: '/annexes-consumers'
                },
                {
                    label: 'Contribuyentes',
                    icon: 'pi pi-briefcase',
                    routerLink: ['/annexes-taxpayers'],
                    path: '/annexes-taxpayers'
                }
            ]
        };
    }
}
